import React from 'react';

function Label(props) {
  return (
    <div className={`label ${props.className}`}>
      <p>{props.label}</p>
    </div>
  );
}

export default Label;
